import { useState, useEffect } from 'react';
import useMediaQuery from '@src/hooks/useMediaQuery';

type Options = {
  navigation?: {
    mobile: boolean;
    desktop: boolean;
  };
  pagination?: {
    mobile: boolean;
    desktop: boolean;
  };
  scrollbar?: {
    mobile: boolean;
    desktop: boolean;
  };
};

export function useSwiperModulesDisabledClassToggle(options: Options) {
  // States
  const [swiperDisabledClass, setSwiperDisabledClass] = useState('');

  // Hooks
  const isDesktop = useMediaQuery(1024);
  const isMobile = useMediaQuery(undefined, 1023);

  useEffect(() => {
    const keys = ['navigation', 'pagination', 'scrollbar'];

    let classes = '';
    if (isDesktop) {
      for (const key of keys) {
        if (options[key]) {
          if (!options[key].desktop) classes += ` swiper-${key}-disabled`;
        }
      }
    }

    if (isMobile) {
      for (const key of keys) {
        if (options[key]) {
          if (!options[key].mobile) classes += ` swiper-${key}-disabled`;
        }
      }
    }

    setSwiperDisabledClass(classes);
  }, [isDesktop, isMobile]);

  return {
    swiperDisabledClass
  };
}
